import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import { get } from 'lodash';

import { replaceWithAbsolutePath } from '../../lib/media-path-replacer';

import { connect } from 'react-redux';
import { SharedTextContent } from '../exercise/shared-text/components';
import { SOURCES } from '../../constants/sources.js';

export const SharedText = ({ exercise, showExpandButton = false, source }) => {
    const isUnitutor = source === SOURCES.ZTE_UNITUTOR;
    const title = isUnitutor ? get(exercise, 'sharedText.title') : get(exercise, 'sharedText.publicTitle');
    const publicTitle = get(exercise, 'sharedText.publicTitle');
    const content = replaceWithAbsolutePath(get(exercise, 'sharedText.content'));

    return (
        <SharedTextContent
            title={title}
            publicTitle={publicTitle}
            content={content}
            isUnitutor={isUnitutor}
            showExpandButton={showExpandButton}
            isDefaultOpen={false}
        />
    );
};

SharedText.propTypes = {
    exercise: PropTypes.object,
    showExpandButton: PropTypes.bool,
    source: PropTypes.string,
};

const mapStateToProps = (state) => {
    return {
        source: state.application.source,
    };
};

export default connect(mapStateToProps)(SharedText);
